import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { ClientLog, ClientLogMetadata } from '../../../shared/lib/ClientLog.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/logs' }

type Params = never
type Body = { metadata: ClientLogMetadata; logs: ClientLog[]; batchId?: UUID }
type Query = never
type Output = never

export type AddEndpoint = Endpoint<Params, Body, Query, Output>

export const addRequest = (request: Request, args: RequestArgs<AddEndpoint>) => request<AddEndpoint>(route, args)
